import React from 'react';
import { SvgIcon } from '@material-ui/core';
import styled from 'styled-components';
const StyledIcon = styled(SvgIcon) `
  ${({ theme: { palette } }) => `
    fill: ${palette.primary.contrastText};
  `}
`;
const ArrowUpward = () => {
    return (React.createElement(StyledIcon, null,
        React.createElement("path", { d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" })));
};
export default ArrowUpward;
